const TOUR_STORAGE_PREFIX = "aq_faq_assist_tour_v1";

export function getFaqAssistTourStorageKey(staffId) {
  const id = String(staffId || "").trim();
  return id ? `${TOUR_STORAGE_PREFIX}_${id}` : TOUR_STORAGE_PREFIX;
}

export function hasCompletedFaqAssistTour(staffId) {
  try {
    return localStorage.getItem(getFaqAssistTourStorageKey(staffId)) === "1";
  } catch {
    return false;
  }
}

export function markFaqAssistTourCompleted(staffId) {
  try {
    localStorage.setItem(getFaqAssistTourStorageKey(staffId), "1");
  } catch {
    /* ignore quota errors */
  }
}
